<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <template slot="slide-form">

            <form data-vv-scope="xxx" @click.alt="testFillForm()">
                <!--============================================================================================================-->
                <!--
                <v-layout row>
                    <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
                </v-layout>
                -->
                <!--============================================================================================================ -->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Fragen zum Hausrat</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <v-flex xs12 style=" font-size: 0.9em;">
                        <Anzeigepflicht-Block><!-- TextBlock mit Hinweis zur Pflicht alle Daten korrekt anzugeben--></Anzeigepflicht-Block>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Der zu versichernde Hausrat muss sich in einem Gebäude der Bauartklasse 1 befinden, d.h.:
                        <br>
                        <ul>
                            <li>Außenwände in allen Teilen (einschließlich tragender Konstruktion) aus feuerbeständigen, massiven Bauteilen/Baustoffe (Gilt auch für Fertighäuser)</li>
                            <li>Dacheindeckung hart, z.B. Ziegel, Schiefer, beton, Asbestzementplatten, Metall, gesandete Dachpappe.</li>
                        </ul>
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.hr_jn_bauweise"
                                           v-model="value.fieldValues"
                                           direction="row"
                                           :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Die Art der Konstruktion der Bauweise des Gebäudes. Dieser hat Einfluss auf die Beitragsermittlung.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :class="{hr_bauklasse:true}" :fielddef="fieldDefs.hr_bauklasse" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Ihre zu versichernde Wohnung muss durch ein bündiges Zylinderschloss gesichert sein, welches von außen nicht abschraubbar ist.
                        <br>Ohne diese Mindestsicherung ist kein Versicherungsschutz möglich.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.hr_jn_tueren_gesichert"
                                           v-model="value.fieldValues"
                                           direction="row"
                                           :sub_styles="[{minWidth:'50px', maxWidth:'200px'}, {minWidth:'70px'}]"
                                           :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        Befinden Sich feuergefährliche Betriebe oder Lager im Gebäude oder in der Nachbarschaft, z.B. Gaststätten, Schreinerei, Tankstelle etc.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.hr_jn_feuergefahr"
                                           v-model="value.fieldValues"
                                           direction="row"
                                           :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Als ständig bewohnt gilt eine Wohnung, wenn es nicht länger als 60 Tage unbewohnt und unbeaufsichtigt bleibt.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.hr_jn_bewohnt"
                                           v-model="value.fieldValues"
                                           direction="row"
                                           :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                </v-layout>

                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Sofern sich der zu versichernde Hausrat in einem der genannten Häuser befindet, kann kein Versicherungsschutz gewährt werden.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.hr_jn_ferienhaus"
                                           v-model="value.fieldValues"
                                           direction="row"
                                           :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                </v-layout>



                <!--============================================================================================================-->
            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    import slideMixin from '../stepMixin'
    import _ from 'lodash'
    //import {mapState} from 'vuex'

    export default {
        //========================================================================================================
        name: 'Step_hausrat_II',
        label: 'Fragen zur Wohnung',
        label2: 'Fragen zum<br>Haus/Wohnung',

        fieldKeys: [

            'hr_jn_bewohnt',
            'hr_jn_bauweise',
            'hr_jn_ferienhaus',
            'hr_jn_tueren_gesichert',

            'hr_jn_feuergefahr',
            'hr_bauklasse',

        ],
        //========================================================================================================
        data: function () {
            //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
            //an dieser Stelle können diese Werte überschrieben werden.
            // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
            var fieldDefs_OVERRIDE = {}

            return {
                fieldDefs: fieldDefs_OVERRIDE,
                testList: [1, 2, 3, 4, 5],
                field: null,

            }
        }, //========================================================================================================
        mixins: [slideMixin],
        //===========================================================================================================
        watch: {

            value: {
                handler: function (newVal, oldVal) {
                    console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
                    console.log("WATCHER fieldValues in ", this.$options.label)
                    // var fD = this.fieldDefs
                    var fV = this.value.fieldValues
                    var fVold = this.frmValuesOld

                    var earlyExit = true;
                    for (var key in fV) {
                        if (fV[key] !== fVold[key]) {
                            earlyExit = false
                            console.log("changed ", key, fVold[key], '->', fV[key])
                        }
                    }
                    if (earlyExit === true) {
                        console.log("NO changes -> early EXIT")
                        return;
                    }
                    //----------------------------------------------------------------------------
                    // -> hier evtl. reaktion auf Änderungen von Form-Values

                    //----------------------------------------------------------------------------

                    this.frmValuesOld = _.assign({}, fV)

                },
                deep: true,

            },
        }, //========================================================================================================
        components: {/* programmatically setted by step-mixin*/},
        //===========================================================================================================
        props: [/* programmatically setted by step-mixin*/],
        //===========================================================================================================
        // HOOKS:
        /* programmatically setted by step-mixin*/
        //===========================================================================================================
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>
    .v-menu__content {
        max-height: 500px !important;
    }
</style>
